export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/fortnite.16e14e2.svg";